function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import SpzaComponent from './spzaComponent';
import { Constants } from '@shared/utils/constants';
import { getUserFavouriteEntity } from '@shared/utils/userFavouriteUtils';
import { getWindow } from '@shared/services/window';
import { ActionButton } from '@fluentui/react';
import { logger } from '@src/logger';
const favoriteStarHollow = {
    iconName: 'FavoriteStar'
};
const favoriteStarFilled = {
    iconName: 'FavoriteStarFill'
};
export class UserFavouriteTileDetailButton extends SpzaComponent {
    componentDidMount() {
        this.props.fetchUserFavouriteData();
    }
    setFavouriteItemModifyComplete() {
        this.setState({
            itemModifyStatus: Constants.UserFavourite.DataItemModifyStatus.Done
        });
    }
    onClickUserFavouriteButton() {
        const userFavouriteEntity = getUserFavouriteEntity(this.props.userFavourite, this.props.entityId);
        const upsertPayload = {
            applicationType: this.props.entityType,
            applicationId: this.props.entityId
        };
        // telemetry
        const details = userFavouriteEntity ? {
            action: Constants.Telemetry.Action.Delete,
            userFavouriteInfo: _object_spread({}, userFavouriteEntity)
        } : {
            action: Constants.Telemetry.Action.Upsert,
            userFavouriteInfo: _object_spread({}, upsertPayload)
        };
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.UserFavouriteTileDetailButton,
            details: JSON.stringify(details)
        };
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
        // toggle user favourite on entity
        if (userFavouriteEntity) {
            // Delete a favourite
            // save the user action
            // display saved result beforehand
            this.setState({
                itemModifyStatus: Constants.UserFavourite.DataItemModifyStatus.Delete
            });
            // REST DELETE
            this.props.deleteFavourite(userFavouriteEntity.entityGuid, userFavouriteEntity.applicationType)// TO-DO: cannot use .finally() on promise
            .then(()=>{
                this.setFavouriteItemModifyComplete();
            }).catch(()=>{
                this.setFavouriteItemModifyComplete();
            });
        } else {
            // Upsert a favourite
            // save the user action
            // display saved result beforehand
            this.setState({
                itemModifyStatus: Constants.UserFavourite.DataItemModifyStatus.Upsert
            });
            // REST POST
            this.props.savefavourite(_object_spread({}, upsertPayload), this.props.item)// TO-DO: cannot use .finally() on promise
            .then(()=>{
                this.setFavouriteItemModifyComplete();
            }).catch(()=>{
                this.setFavouriteItemModifyComplete();
            });
        }
    }
    renderImpl() {
        const hasUserSavedFavourite = !!getUserFavouriteEntity(this.props.userFavourite, this.props.entityId);
        const itemModifyStatus = this.state.itemModifyStatus;
        const shouldShowSavedStatus = hasUserSavedFavourite && (itemModifyStatus === Constants.UserFavourite.DataItemModifyStatus.Done || itemModifyStatus === Constants.UserFavourite.DataItemModifyStatus.None) || !hasUserSavedFavourite && itemModifyStatus === Constants.UserFavourite.DataItemModifyStatus.Upsert;
        const title = shouldShowSavedStatus ? this.context.loc('UserFavourite_TileDetailButton_Saved') : this.context.loc('UserFavourite_TileDetailButton_Save');
        return this.props.userInfo.signedIn && /*#__PURE__*/ _jsx(ActionButton, {
            iconProps: hasUserSavedFavourite ? favoriteStarFilled : favoriteStarHollow,
            allowDisabledFocus: true,
            onClick: this.onClickUserFavouriteButton,
            className: this.props.className,
            children: title
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0);
        this.state = {
            // this state property is to fix the flicker when user (un)save an favourite, due to the delay of a REST call to server
            // makes user think (un)save is an immediate action to effect,
            // this is done by changing the classname before the REST call, and reset the classname after REST call
            // in order to change and change it back, we need to record the user action
            itemModifyStatus: Constants.UserFavourite.DataItemModifyStatus.None
        };
        this.onClickUserFavouriteButton = this.onClickUserFavouriteButton.bind(this);
    }
}
UserFavouriteTileDetailButton.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func,
    buildHref: PropTypes.func,
    renderErrorModal: PropTypes.func
};
